import React, { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Differentiator } from "./components/Differentiator";
import { About } from "./components/About";
import { Clients } from "./components/Clients";
import { TrustPillars } from "./components/TrustPillars";
import { CTASection } from "./components/CTASection";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[#050507] text-white antialiased selection:bg-[#0047ff]">
        <Header />
        <main>
          <Hero />
          <Services />
          <Differentiator />
          <About />
          <Clients />
          <TrustPillars />
          <CTASection />
          <Contact />
        </main>
        <Footer />
        <FloatingWhatsApp />
        <Toaster theme="dark" position="bottom-center" richColors closeButton />
      </div>
    </LanguageProvider>
  );
}

export default App;
